import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({ providedIn: 'root' })
export class ErrorLoggerService {
  //Injectbales
  private _console = inject(Tools_aiConsoleService);

  constructor(private http: HttpClient) {}

  logError(error: any, context: string = ''): void {
    const errorLog = {
      timestamp: new Date().toISOString(),
      message: error.message || 'Unknown error',
      stack: error.stack || '',
      context: context,
      userAgent: navigator.userAgent,
      url: window.location.href
    };

    this._console.error('Error Logger:', errorLog); //imprimir en consola
  }
}
